<style lang="scss">
.zoezi-grouptraining {
    .list{
        display:block;
        transition: all 250ms ease-in-out;
        position:relative;
        .item{
            display:flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            width:100%;
            overflow:hidden;
            border-radius:4px;
            margin-bottom:10px;
            box-shadow:
                0 1px 3px  rgba(0,0,0,.2),
                0 3px 3px  rgba(0,0,0,0),
                0 9px 9px rgba(0,0,0,0);
            transition:all 250ms ease-in-out;
            &:hover{
                box-shadow:
                    0 1px 3px  rgba(0,0,0,.2),
                    0 3px 9px  rgba(0,0,0,.1),
                    0 9px 27px rgba(0,0,0,.05);
                .image-block .time{
                    transform:translateY(-31px);
                    left:0;
                    width:100%;
                    border-radius:0;
                }
                .image-block .duration{
                    transform:translateY(30px);
                    left:0;
                    width:100%;
                    border-radius: 0;
                }
            }
            &.cancelled {
                background:#fbeeed;
            }
            .image-block{
                height: 100px;
                width:80px;
                flex-shrink:0;
                overflow: hidden;
                position:relative;
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center center;
                @media(min-width:768px){
                    width:100px;
                }
                .time,
                .duration{
                    background:rgba(0,0,0,.7);
                    position:absolute;
                    left:0; height:40px;
                    width: 80px;
                    line-height: 20px;
                    font-size:20px;
                    padding:20px 0 0 0;
                    text-shadow: 0 1px 3px rgba(0,0,0,.5);
                    text-align: center;
                    color:white;
                    transition:all 250ms ease-in-out;
                    backdrop-filter:blur(5px);
                    @media(min-width:768px){
                        left: 10px;
                    }
                }
                .time{
                    border-top-left-radius: 80px;
                    border-top-right-radius:80px;
                    bottom:50px;
                }
                .duration{
                    top: 50px;
                    border-bottom-left-radius: 90px;
                    border-bottom-right-radius:90px;
                    padding:0;
                    font-size: 16px;
                    letter-spacing: 0.05em;
                }
            }
            .content{
                flex-shrink: 1;
                width: calc(100% - 80px);
                padding: 10px;
                @media(min-width:360px){
                    width:calc(100% - 230px);
                    margin: 10px auto 10px 10px;
                    padding:0;
                }
                h3{
                    margin:0 0 5px 0 !important;
                    font-size: 1.15rem !important;
                    word-break:break-word;
                    hyphens: auto;
                    line-height:1.2em;
                }
                div{
                    max-width:100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    line-height:1em;
                    margin-top: 5px;
                }
                .staff{
                    white-space:nowrap;
                    max-width:100%;
                    overflow:hidden;
                    text-overflow: ellipsis;
                    display:inline-block;
                    line-height:1em;
                    .v-icon{
                        line-height: 12px;
                    }
                }
                .location{
                    opacity:.5;
                    white-space: nowrap;
                    overflow:hidden;
                    text-overflow: ellipsis;
                }
            }
            .zoezi-workout-book-button{
                width:100%;
                padding:0;
                .zoezi-button-thin{
                    width:100%;
                    border-radius:0;
                }
                @media(min-width:360px){
                    width:120px;
                    padding: 5px 5px 0 0;
                    .zoezi-button-thin{
                        border-radius:3px;
                    }
                }

            }
            .zoezi-booked-list {
                border-top: solid 1px rgba(0, 0, 0, .1);
                width: 100%;
                flex-shrink: 0;
                .zoezi-booked-person{
                    border-bottom: solid 1px rgba(0,0,0,.1);
                    &::last-child{
                        border-bottom:none;
                    }
                }
            }

        }
        .item-day{
            padding: 25px 0 5px 0;
            position:sticky;
            z-index: 1;
            top:0;
            background:rgba(255,255,255,.9);
            backdrop-filter:blur(10px);
            padding-left:2px; padding-right:2px;
            margin-left: -2px;
            margin-right:-2px;
            .next-day {
                cursor: pointer;
                text-align: right;
            }
            strong{
                display:block;
                font-size: 1.8em;
                line-height:1;
                font-weight: 900;
            }
            span{
                display:block;
                font-weight:400;
            }
        }
        &.li{
            transform: translateX(200px);
            opacity:0;
        }
        &.ri{
            transform: translateX(-200px);
            opacity:0;
        }
        &.lo{
            transform: translateX(-200px);
            opacity:0;
        }
        &.ro{
            transform: translateX(200px);
            opacity:0;
        }
    }



    .day-title {
        color: #999;
    }

    .pull-right {
        float: right!important;
    }

    .filter-summary {
        background: #f0f0f0;
        border-radius: 4px;
        padding: 10px;
    }

    .sel-filters{
        display:flex;
        flex-wrap: wrap;
        margin: -5px -5px 5px -5px;
        padding:2.5px 2.5px;
        border-radius:4px;
    }

    .sel-filters .sel-filter{
        display:block;
        flex-grow:1;
        flex-shrink: 0;
        white-space: nowrap;
        border:solid 1px #069;
        padding: 2px 18px 2px 5px;
        border-radius: 3px;
        margin: 2.5px;
        background:white;
        max-width: calc(100% - 5px);
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;
    }
    .sel-filters .close{
        line-height:22px;
        position: absolute;
        right: 8px;
        top: 4px;
    }

    .close {
        float: right;
        font-size: 21px;
        font-weight: 700;
        line-height: 1;
        color: #000;
        text-shadow: 0 1px 0 #fff;
        filter: alpha(opacity=20);
        opacity: .2;
    }

    .close:focus, .close:hover {
        color: #000;
        text-decoration: none;
        cursor: pointer;
        filter: alpha(opacity=50);
        opacity: .5;
    }

    .circle{
        width: 15px;
        position: relative;
        height: 15px;
        border-radius: 20px;
        margin-right: 5px;
        display: inline-block;
        background-color: #eee;
        top: 2.5px;
    }

    .desktop-filter {
        position:sticky;
        top: 0;
        z-index: 8;
    }

    .face{
        width:20px;
        height:20px;
        object-fit:cover;
        border-radius:10px;
    }

    .day-scroller {
        position:sticky;
        z-index: 2;
        top:0;
        background:rgba(255,255,255,.9);
        backdrop-filter:blur(10px);
        overflow: inherit;
        scroll-behavior: smooth;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .day-marker-desktop strong {
        display:block;
        font-size: 1.8em;
        line-height:1;
        font-weight: 900;
    }

    .day-marker-desktop:hover {
        color: #333 !important;
    }

    .week-marker strong {
        display:block;
        font-size: 0.8em;
        line-height:1;
        font-weight: 900;
    }

    .week-marker:hover {
        color: #333 !important;
    }

    .sticky-warning-background {
        background:rgba(255,255,255, 1.0) !important;
        z-index: 2 !important;
    }

    .z-thinner-banner {
        .v-banner__wrapper {
            padding: 5px;
        }
    }
}
</style>

<template>
    <v-row class="mx-0" :dense="$vuetify.breakpoint.mobile" v-if="$store.state.settings && $store.state.settings.workoutbooking">
        <v-col lg=3 md=4 cols=12 v-if="showFilter">
            <!-- Filter -->

            <!-- Mobile filter -->
            <v-row class="mx-0" dense v-if="$vuetify.breakpoint.mobile" ref="filter">
                <v-col cols=3>
                    <filter-button :title="$translate('Workout_type')" :items="workoutTypesSearchMatch" icon="mdi-format-list-bulleted-type" ref="filterButtonWorkoutTypes">
                        <template #items="{items}">
                            <div style="overflow-y: auto; max-height: 70vh" class="mx-2">
                                <v-text-field :placeholder="$translate('Search workout type...')" dense v-model="filter.workoutTypeSearch" clearable class="mr-2" />
                                <filter-button-row icon="mdi-bookmark-check-outline" :name="$translate('Only available workouts')" :value="onlyFree" @input="setProp('onlyFree', $event)" />
                                <filter-button-row icon="mdi-ticket-account" :name="$translate('Only for my training card')" :value="filterForMyTrainingCard" @input="setProp('filterForMyTrainingCard', $event)" v-if="$store.state.isLoggedIn" />
                                <filter-button-row icon="mdi-television-play" :name="$translate('Only video workouts')" :value="filterOnlyVideo" @input="setProp('filterOnlyVideo', $event)" />
                                <filter-button-row icon="mdi-playlist-check" :name="$translate('All workout types')" :value="allWorkoutsSelected" @input="selectAllWorkoutTypes($event)" />

                                <v-divider class="mt-2 mb-4" />
                                <filter-button-row
                                    v-for="item in items"
                                    :key="item.id"
                                    :color="item.color"
                                    :name="item.name"
                                    :value="filterWorkoutTypes.includes(item.id)"
                                    @input="setItem(filterWorkoutTypes, item.id, $event, 'filterWorkoutTypes')"
                                />
                            </div>
                        </template>
                    </filter-button>
                </v-col>
                <v-col cols=3>
                    <filter-button :value="filterStaffs" @input="setProp('filterStaffs', $event)" :items="staffs" :title="$translate('Instructor')" icon="mdi-account-check-outline" search :searchText="$translate('Search instructor')" ref="filterButtonStaffs" />
                </v-col>
                <v-col cols=3>
                    <filter-button :title="$translate('Time')" icon="mdi-calendar-clock" ref="filterButtonDate">
                        <template #items="{hide}">
                            <date-picker
                                :value="calculatedFromDateString"
                                @input="setProp('fromDate', $event)"
                                :min-date="$store.state.now30s.clone().clearTime()" @change="hide" />

                            <div class="mx-2 mt-4">
                                <filter-button-row icon="mdi-calendar-today" :name="$translate('All day')" :value="[0,DAY_PERIODS.length].includes(filterDayPeriods.length)" />
                                <filter-button-row
                                    v-for="item in DAY_PERIODS"
                                    :key="item.id"
                                    :color="item.color"
                                    :name="$translate(item.title)"
                                    :icon="item.icon"
                                    :value="filterDayPeriods.includes(item.id)"
                                    @input="setItem(filterDayPeriods, item.id, $event, 'filterDayPeriods')"
                                />
                            </div>
                        </template>
                    </filter-button>
                </v-col>
                <v-col cols=3 v-if="sites && sites.length && hasMultiSites && !globalSiteSetting">
                    <filter-button
                        :value="filterSites"
                        @input="setProp('filterSites', $event)"
                        :title="$translate('Location')"
                        icon="mdi-map-marker-radius-outline"
                        ref="filterButtonSite"
                        :items="sites"
                        search
                        :searchText="$translate('Search location')"
                        :show-color-image-circle="false"
                    />
                </v-col>
            </v-row>

            <!-- Desktop filter -->
            <div v-else class="desktop-filter" :style="{'top': (sticky.top+10) + 'px'}" ref="filter" >
                <filter-button :title="$translate('Workout_type')" :items="workoutTypesSearchMatch" icon="mdi-format-list-bulleted-type" ref="filterButtonWorkoutTypes" horizontal :attach="$refs.filter">
                    <template #items="{items}">
                        <div style="overflow-y: auto; max-height: 70vh" class="mx-2">
                            <v-text-field :placeholder="$translate('Search workout type...')" dense v-model="filter.workoutTypeSearch" clearable class="mr-2" />
                            <filter-button-row icon="mdi-bookmark-check-outline" :name="$translate('Only available workouts')" :value="onlyFree" @input="setProp('onlyFree', $event)" />
                            <filter-button-row icon="mdi-ticket-account" :name="$translate('Only for my training card')" :value="filterForMyTrainingCard" @input="setProp('filterForMyTrainingCard', $event)" v-if="$store.state.isLoggedIn" />
                            <filter-button-row icon="mdi-television-play" :name="$translate('Only video workouts')" :value="filterOnlyVideo" @input="setProp('filterOnlyVideo', $event)" />
                            <filter-button-row icon="mdi-playlist-check" :name="$translate('All workout types')" :value="allWorkoutsSelected" @input="selectAllWorkoutTypes($event)" />

                            <v-divider class="mt-2 mb-4" />
                            <filter-button-row
                                v-for="item in items"
                                :key="item.id"
                                :color="item.color"
                                :name="item.name"
                                :value="filterWorkoutTypes.includes(item.id)"
                                @input="setItem(filterWorkoutTypes, item.id, $event, 'filterWorkoutTypes')"
                            />
                        </div>
                    </template>
                </filter-button>

                <div class="sel-filters" v-if="filterWorkoutTypes.length && workoutTypes.length">
                    <div v-for="sel in filterWorkoutTypes.map(wt => workoutTypes.find(x => wt == x.id)).filter(wt => wt)" :key="sel.id" class="sel-filter"
                         :style="{
                             backgroundColor: h2r(sel.color,.05),
                             borderColor: h2r(sel.color,1)
                         }">
                        <span class="circle" :style="{backgroundColor: sel.color}"></span>
                        {{sel.name}}
                        <b class="close" @click="setItem(filterWorkoutTypes, sel.id, false, 'filterWorkoutTypes')">&times;</b>
                    </div>
                </div>

                <filter-button :value="filterStaffs" @input="setProp('filterStaffs', $event)" :items="staffs" :title="$translate('Instructor')" icon="mdi-account-check-outline" search :searchText="$translate('Search instructor')" ref="filterButtonStaffs" horizontal :attach="$refs.filter"/>

                <div class="sel-filters" v-if="filterStaffs.length && staffs.length">
                    <div v-for="sel in filterStaffs.map(staff => staffs.find(x => staff == x.id)).filter(x => x)" :key="sel.id" class="sel-filter">
                        <img v-if="sel.imagekey" :src="$api.getImageUrl(sel.imagekey, 200)" class="face" />
                        {{sel.name}}
                        <b class="close" @click="setItem(filterStaffs, sel.id, false, 'filterStaffs')">&times;</b>
                    </div>
                </div>

                <filter-button :title="$translate('Time')" icon="mdi-calendar-clock" ref="filterButtonDate" horizontal :attach="$refs.filter">
                    <template #items="{hide}">
                        <date-picker
                            :value="calculatedFromDateString"
                            @input="setProp('fromDate', $event)"
                            :min-date="$store.state.now30s.clone().clearTime()" @change="hide" />

                        <div class="mx-2 mt-4">
                            <filter-button-row icon="mdi-calendar-today" :name="$translate('All day')" :value="[0,DAY_PERIODS.length].includes(filterDayPeriods.length)" />
                            <filter-button-row
                                v-for="item in DAY_PERIODS"
                                :key="item.id"
                                :color="item.color"
                                :name="$translate(item.title)"
                                :icon="item.icon"
                                :value="filterDayPeriods.includes(item.id)"
                                @input="setItem(filterDayPeriods, item.id, $event, 'filterDayPeriods')"
                            />
                        </div>
                    </template>
                </filter-button>

                <div class="sel-filters" v-if="filterDayPeriods.length>0">
                    <div v-for="sel in filterDayPeriods.map(dp => DAY_PERIODS.find(x => dp == x.id))" :key="sel.id" class="sel-filter">
                        <v-icon :color="sel.color">{{sel.icon}}</v-icon>
                        {{$translate(sel.title)}}
                        <b class="close" @click="setItem(filterDayPeriods, sel.id, false, 'filterDayPeriods')">&times;</b>
                    </div>
                </div>

                <template v-if="sites && sites.length && hasMultiSites && !globalSiteSetting">
                    <filter-button
                        :value="filterSites"
                        @input="setProp('filterSites', $event)"
                        :title="$translate('Location')"
                        icon="mdi-map-marker-radius-outline"
                        ref="filterButtonSite"
                        :items="sites"
                        search
                        :searchText="$translate('Search location')"
                        horizontal
                        :attach="$refs.filter"
                        :show-color-image-circle="false"
                    />

                    <!-- FIXME: Replacing v-show with v-if below makes the filter show up above several other filters -->
                    <div class="sel-filters" v-show="filterSites.length>0">
                        <div v-for="sel in filterSites.map(loc => sites.find(x => loc == x.id)).filter(x => x)" :key="sel.id" class="sel-filter">
                            {{sel.name}}
                            <b class="close" @click="setItem(filterSites, sel.id, false, 'filterSites')">&times;</b>
                        </div>
                    </div>
                </template>
            </div>
        </v-col>
        <v-col :lg="showFilter ? 9 : 12" :md="showFilter ? 8 : 12" cols=12>
            <!-- Content -->

            <div class="filter-summary hidden-md-and-up" v-if="showFilter">
                {{$translate('Showing results for')}}
                <span class="z-clickable primary--text" @click="$refs.filterButtonWorkoutTypes.showMenu = true">
                    {{filterWorkoutTypes.length == 0 ? $translate('All workout types') : filterWorkoutTypes.map(x => { let wt = workoutTypes.find(w => w.id == x); return wt ? wt.name : ''}).join(', ') }}
                </span>
                {{$translate('with')}}
                <span class="z-clickable primary--text" @click="$refs.filterButtonStaffs.showMenu = true">
                    {{filterStaffs.length == 0 ? $translate('all instructors') : filterStaffs.map(x => { let staff = staffs.find(w => w.id == x); return staff ? staff.name : ''}).join(', ') }}
                </span>
                <span class="z-clickable primary--text" @click="$refs.filterButtonDate.showMenu = true">
                    {{filterDayPeriods.length == 0 ? $translate('All day').toLowerCase() : filterDayPeriods.map(x => DAY_PERIODS.find(w => w.id == x).name).join(', ') }}
                </span>
                {{$translate('from')}}
                <span class="z-clickable primary--text" @click="$refs.filterButtonDate.showMenu = true">
                    {{Date.formatFullShortRelative(days[0].date)}}
                </span>
                <template v-if="sites && sites.length > 1 && !globalSiteSetting">
                    {{$translate('on')}}
                    <span class="z-clickable primary--text" @click="$refs.filterButtonSite.showMenu = true">
                        {{filterSites.length == 0 ? $translate('all locations') : filterSites.map(x => { let loc = sites.find(w => w.id == x); return loc ? loc.name : ''}).join(', ') }}
                    </span>
                </template>
            </div>

            <div class="z-clickable day-scroller" :style="{'top': sticky.top + 'px'}" ref="scrollerDaysContainer" v-if="visibleDays.length && showDaysRow && $vuetify.breakpoint.mobile && !loadingWorkouts">
                <div class="d-flex" v-if="showWeekPicker">
                    <div class="week-marker pr-4" v-for="week in weeks" :key="week.text" :class="week.selected ? 'primary--text' : 'grey--text'" @click="setWeek(week.date)">
                        <strong>{{week.text}}</strong>
                    </div>
                </div>

                <div class="d-flex mt-2">
                    <div v-for="(day,dayi) in visibleDays" :key="day.date.yyyymmdd()" class="z-1of8 zoezi-button-round zoezi-button-thin">
                        <v-btn
                            @click="setDay(dayi)"
                            ref="scrollerDays"
                            :data-date="day.date.yyyymmdd()"
                            :color="Date.dateEquals(day.date, showingDate) ? 'primary' : undefined"
                            rounded
                            height="32"
                            width="32"
                            class="zoezi-button-thin zoezi-button-round"
                        >
                            {{ Date.dateEquals(day.date, $store.state.now30s) ? $translate('Today').toLowerCase() : $translate(day.date.getWeekDayString().substring(0,3)).toLowerCase()}}
                        </v-btn>
                    </div>
                    <div class="z-1of8 zoezi-button-round zoezi-button-thin" v-if="showFilter">
                        <v-btn
                            rounded
                            height="32"
                            width="32"
                            class="zoezi-button-thin zoezi-button-round"
                            @click="$vuetify.goTo($refs.filter)"
                        ><v-icon>mdi-filter</v-icon></v-btn>
                    </div>
                </div>
            </div>
            <div class="day-scroller" :style="{'top': sticky.top + 'px'}" ref="scrollerDaysContainer" v-if="visibleDays.length && showDaysRow && !$vuetify.breakpoint.mobile && !loadingWorkouts">
                <div class="z-clickable d-flex" v-if="showWeekPicker">
                    <div class="week-marker pr-4" v-for="week in weeks" :key="week.text" :class="week.selected ? 'primary--text' : 'grey--text'" @click="setWeek(week.date)">
                        <strong>{{week.text}}</strong>
                    </div>
                </div>
                <div class="d-flex z-clickable mt-4">
                    <div v-for="(day,dayi) in visibleDays" :key="day.date.yyyymmdd()" class="day-marker-desktop pr-4"
                         @click="setDay(dayi)"
                         ref="scrollerDays"
                         :data-date="day.date.yyyymmdd()"
                         :class="Date.dateEquals(day.date, showingDate) ? 'primary--text' : 'grey--text'"
                    >
                        <strong>{{day.title}}</strong>
                        <span>{{Date.formatFullShorter(day.date)}}</span>
                    </div>
                </div>
            </div>

            <v-banner v-if="isBlocked" icon="mdi-sticker-alert-outline" icon-color="error" sticky :style="{'top': sticky.afterDays + 'px'}" elevation=4 class="sticky-warning-background" ref="warningBanner" two-line>
                <div class="error--text" v-if="!isBlocked.toDate || Date.isMaxDate(isBlocked.toDate)">{{ $translate("You are blocked from group workouts until furhter notice") }}</div>
                <div class="error--text" v-else>{{ $translate('You are blocked from group workouts until {0}').format(Date.formatFullShorter(isBlocked.toDate))}}</div>

                <v-btn v-if="isBlocked.type =='warning'"
                       text
                       color="primary"
                       @click="showWarningsDialog = true"
                >
                    {{$translate('See your warnings')}}
                </v-btn>
                <v-btn v-if="$store.state.settings.blockFeeProductId && isBlocked.type =='warning'"
                       text
                       color="primary"
                       @click="showBlockFeeDialog = true"
                >
                    {{$translate('Unblock')}}
                </v-btn>
            </v-banner>
            <v-banner v-else-if="$store.state.user && $store.state.settings && $store.state.settings.wbswarningsenabled && this.activeWarnings.length > 0" icon="mdi-sticker-alert-outline" icon-color="error" sticky :style="{'top': sticky.afterDays + 'px'}" elevation=4 class="sticky-warning-background z-thinner-banner" ref="warningBanner" two-line>
                <div class="error--text">{{$translate('You have received warnings')}}</div>

                <v-btn
                    text
                    color="primary"
                    @click="showWarningsDialog = true"
                >
                    {{$translate('See your warnings')}}
                </v-btn>
            </v-banner>

            <div v-if="loadingWorkouts" class="text-center">
                {{$translate('Loading...')}} <v-progress-circular indeterminate color="primary" />
            </div>
            <div v-else class="list">
                <div class="list-day" v-for="(day,dayi) in visibleDays" :key="day.date.yyyymmdd()" ref="days" :data-date="day.date.yyyymmdd()">
                    <div class="item-day" :class="{'primary--text': Date.dateEquals(day.date, showingDate)}" :style="{'top': sticky.afterWarning + 'px'}" @click.stop="setDay(dayi)">
                        <div v-if="false && dayi < visibleDays.length - 1" class="pull-right next-day day-title" @click.stop="setDay(dayi+1)">
                            <strong>{{visibleDays[dayi+1].title}}</strong>
                            <span>{{Date.formatFullShorter(visibleDays[dayi+1].date)}}</span>
                        </div>
                        <strong>{{day.title}}</strong>
                        <span>{{Date.formatFullShorter(day.date)}}</span>
                    </div>
                    <div v-if="filteredWorkoutsPerDay[days.findIndex(d => Date.dateEquals(d.date, day.date))].length == 0" class="text--secondary">
                        {{$translate('No activities')}}
                    </div>
                    <div v-for="workout in filteredWorkoutsPerDay[days.findIndex(d => Date.dateEquals(d.date, day.date))]" :key="workout.id">
                        <div class="my-2 item" @click="showWorkoutDialog = true; showingWorkout = workout" :class="{cancelled: workout.isCancelled()}">
                            <div class="image-block" :style="getWorkoutBackground(workout)">
                                <div class="time" :style="{backgroundColor: h2r(workout.workoutType.color, (workoutTypeOpacity / 100))}">{{workout.startTime.hhmm()}}</div>
                                <div class="duration" :style="{backgroundColor: h2r(workout.workoutType.color, (workoutTypeOpacity / 100))}">{{(workout.endTime - workout.startTime) / 60000}} {{$translate('MINUTES_SHORT')}}</div>
                            </div>
                            <div class="content">
                                <h3 class="title">{{workout.workoutType.name + (workout.extra_title ? ' - ' + workout.extra_title : '')}}</h3>
                                <span v-if="workout.staffs.length">
                                    <span class="staff mr-2" v-for="staff in workout.staffs" :key="staff.id">
                                        <img v-if="staff.imagekey" :src="$api.getImageUrl(staff.imagekey, 100)" style="width:16px; border-radius:50%;">
                                        <v-icon v-if="!staff.imagekey" small color="primary">mdi-account</v-icon>
                                        {{staff.name}}
                                    </span>
                                </span>
                                <div class="location" v-if="workout.location || workout.room">
                                    <v-icon small color="primary">mdi-map-marker</v-icon>
                                    <span v-if="workout.room">{{workout.room.name}}{{workout.location ? ', ': ' '}}</span>
                                    <span v-if="workout.location">{{workout.location.name}}</span>
                                </div>
                            </div>
                            <workout-book-button :workout="workout" :showNumBooked="computedShowNumBooked" />

                            <div class="zoezi-booked-list" v-if="$store.state.user" :data-these-can-book-text="$translate('These can book')">
                                <workout-book-user-row
                                    class="zoezi-booked-person"
                                    :workout="workout"
                                    :user="user"
                                    v-for="user in $store.state.user.canBookFor.filter(u => workout.isBooked(u))"
                                    :key="user.id"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <v-btn class="zoezi-button-thin float-right" color="primary" @click="setNextWeek"><span class="primarytext--text">{{$translate('Next week')}}</span></v-btn>
            </div>

            <workout-dialog v-model="showWorkoutDialog" :workout="showingWorkout" :showNumBooked="computedShowNumBooked" :invite="workoutInvite" :showLastnameForInstructors="showLastnameForInstructors" v-if="showWorkoutDialog" />

            <v-dialog v-if="showBlockFeeDialog" v-model="showBlockFeeDialog" scrollable max-width="850px" :fullscreen="$vuetify.breakpoint.mobile">
                <v-card tile elevation="0" class="z-no-x-scroll">
                    <v-card-title class="headline pa-2 primary primarytext--text d-flex fill-width">
                        <v-spacer />
                        <v-btn icon @click="showBlockFeeDialog = false"><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                    </v-card-title>
                    <zoezi-checkout class="zoezi-checkout" :items="[{product_id: $store.state.settings.blockFeeProductId}]" />
                </v-card>
            </v-dialog>

            <v-dialog v-if="showWarningsDialog" v-model="showWarningsDialog" scrollable max-width="850px">
                <v-card tile elevation="0" class="z-no-x-scroll">
                    <v-card-title class="headline pa-2 primary primarytext--text d-flex fill-width">
                        <v-icon class="primary primarytext--text mr-2">mdi-sticker-alert-outline</v-icon>
                        {{$translate('Warnings')}}
                        <v-spacer />
                        <v-btn icon @click="showWarningsDialog = false"><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                    </v-card-title>

                    <v-card-text>
                        {{$translate('After {0} warnings, your account will be locked for {1} days or until the fine is paid. While the account is locked, it is not possible to make bookings.').format($store.state.settings.wbswarninglimit, $store.state.settings.wbswarningduration)}}

                        <div class="font-weight-bold mt-4">{{$translate('You have been warned on the following occasions')}}</div>
                        <ul v-if="$store.state.user.warnedUntil">
                            <li v-for="warning in $store.state.user.recentWarnings" :key="warning.id">
                                <span class="font-weight-bold" v-if="getWarningTime(warning)">{{Date.newFull(getWarningTime(warning)).yyyymmdd()}}</span>
                                <span class="ml-2">{{warning.reason}}</span>
                            </li>
                        </ul>
                        <ul v-else-if="activeWarnings.length > 0">
                            <li v-for="warning in activeWarnings" :key="warning.id">
                                <span class="font-weight-bold" v-if="getWarningTime(warning)">{{Date.newFull(getWarningTime(warning)).yyyymmdd()}}</span>
                                <span class="ml-2">{{warning.reason}}</span>
                            </li>
                        </ul>
                    </v-card-text>

                    <v-card-actions>
                        <v-btn v-if="$store.state.settings.blockFeeProductId && $store.state.user.blocks.find(x => x.type == 'warning')"
                               class="zoezi-button-thin"
                               color="primary"
                               block
                               @click="showBlockFeeDialog = true"
                        >
                            {{ $translate('Unblock') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-col>
    </v-row>
</template>

<script>
import FilterButton from '../components/FilterButton.vue'
import FilterButtonRow from '../components/FilterButtonRow.vue'
import DatePicker from '../components/DatePicker.vue'
import WorkoutDialog from '../components/WorkoutDialog.vue'
import {DAY_PERIODS} from '../util.js'
import WorkoutBookButton from '../components/WorkoutBookButton.vue'
import WorkoutBookUserRow from '../components/WorkoutBookUserRow.vue'
import * as Sentry from '@sentry/browser'
export default {
    name: 'zoezi-grouptraining',

    zoezi: {
        title: 'Group training schedule',
        icon: 'mdi-calendar',
        getDefaultStyle: () => ({
            pageParams: [
                {
                    id: 'pass',
                    prop: 'workout'
                }
            ]
        })
    },

    components: {
        FilterButton,
        DatePicker,
        WorkoutDialog,
        FilterButtonRow,
        WorkoutBookButton,
        WorkoutBookUserRow
    },

    props: {
        categories: {
            title: 'Categories',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                placeholder: 'Show all categories',
                getItems: () => window.$booking.getWorkoutCategories()
            },
            default: () => []
        },
        filterWorkoutTypes: {
            title: 'Filter by activity types',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                getItems: () => window.$booking.getWorkoutTypes()
            },
            default: () => []
        },
        filterStaffs: {
            title: 'Filter by staff',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                getItems: () => window.$zoeziapi.get('/api/public/staff/get/full').then(staffs => staffs.sort((a,b) => a.name.localeCompare(b.name)))
            },
            default: () => []
        },
        filterSites: {
            title: 'Filter by site',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                getItems() {
                    return window.$zoeziapi.get('/api/public/settings/get').then(settings => {
                        return settings.sites.sort((a,b) => a.name.localeCompare(b.name));
                    });
                },
                text: 'name',
                value: 'id',
                multiple: true
            },
            default: () => []
        },
        filterDayPeriods: {
            title: 'Filter by time of day',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'title',
                value: 'id',
                getItems: () => DAY_PERIODS
            },
            default: () => []
        },
        onlyFree: {
            title: 'Only available workouts',
            type: Boolean,
            default: false
        },
        filterForMyTrainingCard: {
            title: 'Only for my training card',
            type: Boolean,
            default: false
        },
        filterOnlyVideo: {
            title: 'Only video workouts',
            type: Boolean,
            default: false
        },
        fromDate: {
            title: 'Show from date',
            type: String,
            fulltype: 'date',
            default: null
        },
        showFilter: {
            title: 'Show filters',
            type: Boolean,
            default: true
        },
        showNumBooked: {
            title: 'Show number of seats/booked',
            type: Boolean,
            default: true
        },
        showDaysRow: {
            title: 'Show row with days',
            type: Boolean,
            default: true
        },
        workout: {
            title: 'Show workout',
            type: Number
        },
        showWeekPicker: {
            title: 'Show week selector',
            type: Boolean,
            default: true
        },
        workoutTypeOpacity: {
            title: 'Opacity for workout type in list',
            type: Number,
            fulltype: 'number-slider',
            typeinfo: {
                min: 0,
                max: 100,
                step: 1,
            },
            default: 80,
        },
        globalSiteSetting: {
            title: 'Filter by globally selected site',
            type: Boolean,
            default: true
        },
        showLastnameForInstructors: {
            title: 'Show last name for instructors',
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        workouts: [],
        workoutTypes: [],
        unsubscribe: [],
        showWorkoutDialog: false,
        showingWorkout: null,
        loadingWorkouts: false,
        progress: {
            workouts: []
        },
        filter: {
            workoutTypeSearch: '',
        },
        showingDate: null,
        banner: {
            warning: null,
            days: null
        },
        showBlockFeeDialog: false,
        showWarningsDialog: false,
        workoutInvite: null,
    }),
    watch: {
        fromDate() {
            this.fetchWorkouts(true);
        },
        workout: {
            immediate: true,
            handler(workout) {
                if (workout) {
                    this.fetchShowingWorkout(workout);
                }
            }
        },
        showWorkoutDialog(show) {
            /* This could probably be made more generic and be reused */
            if (this.$parent && this.$parent.$options.name == 'ComponentWrapper' && this.$parent.config) {
                let pageParam = this.$parent.config.style?.pageParams?.find(p => p.prop == 'workout');
                if (pageParam) {
                    let part = pageParam.id == 'id' ? 'params' : 'query';
                    let hasPageParamInPath = this.$route[part][pageParam.id] !== undefined;

                    let route = {
                        name: this.$route.name,
                        params: Object.assign({}, this.$route.params),
                        query: Object.assign({}, this.$route.query)
                    }

                    try {
                        let ecommerceTrackingItem = {
                            id: 'w' + this.showingWorkout.workoutType.id,
                            name: this.showingWorkout.workoutType.name,
                            price: this.showingWorkout.workoutType.price,
                            vat: this.showingWorkout.workoutType.vat,
                        }
                        this.$ecommercetracking.viewItem(ecommerceTrackingItem);
                    } catch(error) {
                        Sentry.captureException(error);
                    }

                    if (show) {
                        if (!hasPageParamInPath) {
                            route[part][pageParam.id] = this.showingWorkout.id;
                            this.$router.replace(route);
                        }
                    } else {
                        if (hasPageParamInPath) {
                            delete route[part][pageParam.id];
                            this.$router.replace(route);
                        }
                    }
                }
            }
        },
        '$vuetify.breakpoint.width'() {
            this.$nextTick( () => this.updateBannerHeights());
        }
    },
    computed: {
        activeWarnings(){
            let activeWarnings = this.$store.state.user?.recentWarnings?.filter(warning => warning.deprecated == null)
            return activeWarnings || [];
        },
        DAY_PERIODS() {
            return DAY_PERIODS;
        },
        allWorkoutsSelected() {
            return this.filterWorkoutTypes.length == 0 || this.filterWorkoutTypes.length == this.workoutTypes.length;
        },
        workoutTypesSearchMatch() {
            let s = (this.filter.workoutTypeSearch || '').toLowerCase();
            return this.workoutTypes.filter(x => !s || x.name.toLowerCase().includes(s))
        },
        calculatedFromDate() {
            let d = Date.newFull(this.fromDate);
            let invalid = !d || !(d instanceof Date) || isNaN(d);
            return invalid ? Date.today() : d;
        },
        calculatedFromDateString() {
            return this.calculatedFromDate.yyyymmdd();
        },
        calculatedToDate() {
            return this.calculatedFromDate.clone().addDays(6);
        },
        days() {
            let days = [];
            let d = this.calculatedFromDate.clone();
            while (d <= this.calculatedToDate) {
                let title = d.isToday() ? this.$translate('Today').toLowerCase() : (Date.dateEquals(d, Date.tomorrow()) ? this.$translate('Tomorrow').toLowerCase() : this.$translate(d.getWeekDayString()).toLowerCase()  );
                days.push( { date: d.clone(), title } );
                d = d.addDays(1);
            }

            return days;
        },
        visibleDays() {
            return this.days.filter((day, index) => {
                return this.filteredWorkoutsPerDay[index].length > 0 || true;
            });
        },
        weeks() {
            if (!this.showingDate) {
                return [];
            }
            const NUM_WEEKS = 4;
            let res = [];
            for (let i=0; i < NUM_WEEKS; ++i) {
                let date = new Date().addDays(7*i).monday();
                let nr = date.getWeekNumber();
                let text = this.$translate('Week') + ' ' + nr;
                if (nr == Date.today().getWeekNumber()) {
                    text = this.$translate('This week');
                }
                let selected = this.showingDate.getWeekNumber() == nr;
                res.push({date, text, selected, nr});
            }
            return res;
        },
        filteredWorkouts() {
            let toTime = this.calculatedToDate.clone().addDays(1);
            let workouts = this.workouts.filter(x => !this.categories || this.categories.length == 0 || this.categories.find(c => x.workoutType.category_id == c))
                .filter(workout => {
                    let category = workout.getCategory();
                    let bookableTo = category?.allowBookingAfterStarted ? workout.endTime.clone() : workout.startTime.clone();
                    return bookableTo >= this.$store.state.now30s && workout.startTime >= this.calculatedFromDate && workout.startTime <= toTime;
                }).filter(workout => {
                    if (this.filterWorkoutTypes.length == 0) {
                        return true;
                    }

                    return this.filterWorkoutTypes.indexOf(workout.workoutType.id) != -1;
                }).filter(workout => {
                    if (this.filterStaffs.length == 0) {
                        return true;
                    }

                    return this.filterStaffs.find(staff_id => workout.staffs.find(ws => ws.id == staff_id) );
                }).filter(workout => {
                    if (this.filterDayPeriods.length == 0) {
                        return true;
                    }

                    let startHour = workout.startTime.getHours();
                    let period = DAY_PERIODS.find(d => startHour >= d.start && startHour < d.end);
                    return this.filterDayPeriods.indexOf(period.id) != -1;
                }).filter(workout => {
                    if (!this.filterOnlyVideo) {
                        return true;
                    }

                    return workout.video;
                }).filter(workout => {
                    if (!this.onlyFree) {
                        return true;
                    }

                    return !workout.isBooked() && !workout.isFull();
                }).filter(workout => {
                    if (!this.filterForMyTrainingCard) {
                        return true;
                    }

                    return workout.hasValidTrainingCard();
                }).filter(workout => {
                    // If filterSites has values, it takes precedence
                    if (this.filterSites.length > 0) {
                        return this.filterSites.includes(workout.site_id);
                    }

                    // If globalSiteSetting is true, use selectedSiteId
                    if (this.globalSiteSetting) {
                        const selectedSiteId = this.$store.state.selectedSiteId;
                        return !selectedSiteId || workout.site_id == selectedSiteId;
                    }

                    // If none of the above conditions are met, return true
                    return true;
                })

            return workouts.sort((a,b) => a.startTime - b.startTime);
        },
        filteredWorkoutsPerDay() {
            return this.days.map(day => this.filteredWorkouts.filter(w => Date.dateEquals(day.date, w.startTime)))
        },
        staffs() {
            let staffs = [];
            this.workouts.forEach(w => {
                w.staffs.forEach(staff => {
                    staff.name = this.showLastnameForInstructors ? staff.firstname + ' ' + staff.lastname : staff.firstname + ' ' + staff.lastname.substring(0,1);
                    if (!staffs.find(s => s.id == staff.id)) {
                        staffs.push({id: staff.id, name: staff.name, imagekey: staff.imagekey});
                    }
                })
            });

            return staffs.sort( (a,b) => a.name.localeCompare(b.name));
        },
        locations() {
            let locations = [];
            this.workouts.forEach(w => {
                w.resources.forEach(resource => {
                    if (!locations.find(r => r.id == resource.id)) {
                        locations.push({id: resource.id, name: resource.name, imagekey: resource.imagekey, color: 'white', sites: resource.sites});
                    }
                })
            });

            return locations.sort( (a,b) => a.name.localeCompare(b.name));
        },
        sticky() {
            let res = {
                top: this.$root.siteconfig.appbar.props.prominent && !this.$vuetify.breakpoint.mobile ? 128 : 56
            };
            res.afterDays = res.top + this.banner.days;
            res.afterWarning = res.afterDays + this.banner.warning;

            return res;
        },
        hasMultiSites() {
            return this.$store.state.settings?.sites?.length > 1;
        },
        sites() {
            let sites = this.$store.state.settings && this.$store.state.settings.sites;
            return sites?.filter(s => this.workouts.find(w => w.site_id == s.id)).sort( (a,b) => a.name.localeCompare(b.name));
        },
        isBlocked() {
            return this.$store.state.user?.isBlocked('block_grouptraining');
        },
        computedShowNumBooked() {
            return this.$store.state.settings?.wbshowbookingcount ? this.showNumBooked : false;
        }
    },
    methods: {
        getWorkoutTypes() {
            this.$booking.getWorkoutTypes().then(x => {
                this.workoutTypes = x ? x.sort((a,b) => a.name.localeCompare(b.name)) : []
            });
        },
        fetchWorkouts(scrollToFirstDay) {
            let fromDate = this.calculatedFromDate.yyyymmdd()
            let toDate = this.calculatedToDate.yyyymmdd()
            if (!this.workouts || this.workouts.length == 0) {
                this.loadingWorkouts = true;
            }
            this.showingDate = this.calculatedFromDate.clone();

            return this.$api.get('/api/public/workout/get/all', {fromDate, toDate}).then(data => {
                data.workouts.forEach(x => this.$booking.transformWorkout(x))
                this.workouts = data.workouts
                this.loadingWorkouts = false;
                if (scrollToFirstDay) {
                    this.$nextTick(() => this.setDay(0));
                }
            });
        },
        setDay(dayi) {
            let elm = this.$refs.days.find(elm => elm.getAttribute('data-date') == this.visibleDays[dayi].date.yyyymmdd())
            let offset = this.banner.days;
            if (this.banner.warning) {
                offset += this.banner.warning;
            }
            this.$vuetify.goTo(elm, {offset});
        },
        setItem(list, id, selected, prop) {
            let i = list.indexOf(id);
            if (prop) {
                list = list.slice();
            }
            if (selected && i == -1) {
                list.push(id);
            } else if (!selected && i != -1) {
                list.splice(i, 1);
            }

            if (prop) {
                this.setProp(prop, list);
            }
        },
        selectAllWorkoutTypes(selected) {
            if (selected) {
                this.setProp('filterWorkoutTypes', [])
            }
        },
        getWorkoutBackground(workout) {
            if (!workout.workoutType.imagekey) {
                return null;
            }
            return {
                'background-image': 'url(' + this.$api.getImageUrl(workout.workoutType.imagekey, 200) + ')'
            }
        },
        h2r(hex, opacity) {
            let c;
            if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
                c = hex.substring(1).split('');
                if(c.length== 3){
                    c= [c[0], c[0], c[1], c[1], c[2], c[2]];
                }
                c= '0x'+c.join('');
                if(opacity>1) opacity = 1;
                if(opacity<0) opacity = 0;
                return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+opacity+')';
            }
            return 'rgba(0,0,0,1)';
        },
        onScroll() {
            let day = null;
            this.$refs.days?.forEach(elm => {
                if (elm.getBoundingClientRect().top <= (this.sticky.afterWarning + 20)) {
                    day = elm;
                }
            })
            if (day) {
                let d = Date.newFull(day.getAttribute('data-date'));
                if (!Date.dateEqualsObjects(d, this.showingDate)) {
                    this.showingDate = d;
                }
            }
        },
        updateBannerHeights() {
            if (this.$refs.warningBanner && this.$refs.warningBanner.$el) {
                this.banner.warning = this.$refs.warningBanner.$el.clientHeight;
            } else {
                this.banner.warning = 0;
            }

            if (this.$refs.scrollerDaysContainer) {
                this.banner.days = this.$refs.scrollerDaysContainer.clientHeight;
            } else {
                this.banner.days = 0;
            }
        },
        fetchShowingWorkout(workout_id) {
            this.$api.get('/api/public/workout/get', {id: workout_id}).then(workout => {
                this.$booking.transformWorkout(workout)
                this.showingWorkout = workout;
                this.showWorkoutDialog = true;
            })
        },
        setWeek(date) {
            if (date < Date.today()) {
                date = Date.today();
            }
            this.setProp('fromDate', date.yyyymmdd());
        },
        setNextWeek() {
            this.setWeek(this.calculatedFromDate.clone().monday().addDays(7));
        },
        getWarningTime(warning){
            return warning.workout?.startTime || warning.created;
        },
        checkInviteHash(linkHash) {
            this.$api.get('/api/workoutBooking/invites/checkAnswerPermission', { workout_id: this.showingWorkout.id, linkHash: linkHash}).then((permissionResult) => {
                this.workoutInvite = {
                    workoutId: this.showingWorkout.id,
                    linkHash: linkHash,
                    hasResponded: !permissionResult
                }
            });
        }
    },
    created() {
        this.getWorkoutTypes();

        this.unsubscribe.push(this.$booking.subscribeWorkoutChanges(this.workouts));

        this.unsubscribe.push(this.$root.$api.subscribe({type: 'workoutbooking', callback: (_, event) => {
            event.data.forEach(item => {
                // Update numBooked and numQueue for workout
                let w = this.workouts.find(x => x.id == item.workout);
                if (w) {
                    w.numBooked = item.numBooked;
                    w.numQueue = item.numQueue;
                }
            })
        }}))

        this.unsubscribe.push(this.$root.$api.subscribe({type: 'workouttype', callback: () => {
            this.fetchWorkouts();
            if (this.showingWorkout) {
                this.fetchShowingWorkout(this.showingWorkout.id);
            }
        }}))
    },
    beforeUpdate() {
        this.updateBannerHeights();
    },
    mounted() {
        this.fetchWorkouts().then(() => {
            let linkHash = this.$route.query.hash;
            if (linkHash) {
                this.checkInviteHash(linkHash);
            }
        });
        window.addEventListener('scroll', this.onScroll);
    },
    destroyed() {
        this.unsubscribe.forEach(u => {
            if (u) {
                u();
            }
        })
        window.removeEventListener('scroll', this.onScroll);
    }
}
</script>
